<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <v-expansion-panels multiple v-model="panel">

                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-row
                        align="center"
                        class="spacer"
                        no-gutters
                      >
                        <v-col
                          cols="4"
                          sm="2"
                          md="1"
                        >
                          <v-avatar size="36px">
                            <v-icon color="red">assistant_direction</v-icon>
                          </v-avatar>
                        </v-col>

                        <v-col
                          class="hidden-xs-only"
                          sm="5"
                          md="3"
                        >
                          <strong>DATOS DEL CLIENTE</strong>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card flat>
                        <v-card-text>
                          <template>
                            <v-form ref="searchProductForm">
                              <v-container>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="6"
                                  >
                                    <v-text-field
                                      v-model="findClient"
                                      label="Nombre / Apellido / DNI o CE / # Celular"
                                      :rules="[rules.required]"
                                      outlined
                                      dense
                                      @input="onInputFindClient"
                                      v-on:keyup.enter="searchClient()"
                                    ></v-text-field>
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="2"
                                  >
                                    <v-btn
                                      :disabled="findClient ? false : true"
                                      color="primary"
                                      block
                                      depressed
                                      @click="searchClient()"
                                    >
                                      <v-icon dark>
                                        manage_search
                                      </v-icon>
                                    </v-btn>
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="2"
                                    offset-md="2"
                                  >
                                    <v-dialog
                                      ref="dialog"
                                      v-model="modalDeliveryDay"
                                      :return-value.sync="date"
                                      persistent
                                      width="290px"
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                          v-model="dateText"
                                          label="Fecha de Apertura"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                          outlined
                                          dense
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="date"
                                        locale="es"
                                        scrollable
                                      >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="modalDeliveryDay = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="$refs.dialog.save(date)"
                                        >
                                          OK
                                        </v-btn>
                                      </v-date-picker>
                                    </v-dialog>
                                  </v-col>
                                    <v-col
                                      cols="12"
                                      md="3"
                                    >
                                      <v-text-field
                                        v-model.trim="client.name"
                                        label="Nombre"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>
                                    <v-col
                                      cols="12"
                                      md="3"
                                    >
                                      <v-text-field
                                        v-model.trim="client.last_name"
                                        label="Apellido"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>
                                    <v-col
                                      cols="12"
                                      md="3"
                                    >
                                      <v-text-field
                                        v-model.trim="client.identification_doc"
                                        label="DNI/CE"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>
                                    <v-col
                                      cols="12"
                                      md="3"
                                    >
                                      <v-text-field
                                        v-model.trim="client.phone"
                                        label="Celular"
                                        :rules="[rules.required]"
                                        @input="client.phone = client.phone.replace(/\s+/g, '')"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>
                                    <v-col
                                      cols="12"
                                      md="4"
                                    >
                                      <v-select
                                        v-model="address.shipping_type_id"
                                        :items="select.deliveryTypes"
                                        item-value="id"
                                        item-text="name"
                                        label="Tipo de Entrega"
                                        dense
                                        outlined
                                        clearable
                                      ></v-select>
                                    </v-col>

                                    <template v-if="address.shipping_type_id == 1 || address.shipping_type_id == 2">
                                      <v-col
                                        cols="12"
                                        md="4"
                                      >
                                        <v-select
                                          v-model="address.department_id"
                                          :items="address.shipping_type_id == 1 ? select.departments : filteredDepartments"
                                          item-value="id"
                                          item-text="name"
                                          label="Departamento"
                                          dense
                                          outlined
                                        ></v-select>
                                      </v-col>

                                      <v-col
                                        cols="12"
                                        md="4"
                                      >
                                        <v-select
                                          v-model="address.province_id"
                                          :items="address.shipping_type_id == 1 ? select.provinces : filteredProvinces"
                                          item-value="id"
                                          item-text="name"
                                          label="Provincia"
                                          dense
                                          outlined
                                        ></v-select>
                                      </v-col>

                                      <v-col
                                        cols="12"
                                        md="4"
                                      >
                                        <v-select
                                          v-model="address.district_id"
                                          :items="address.shipping_type_id == 1 ? select.districts : filteredDistricts"
                                          item-value="id"
                                          item-text="name"
                                          label="Distrito"
                                          dense
                                          outlined
                                        ></v-select>
                                      </v-col>
                                    </template>

                                    <v-col
                                      cols="12"
                                      md="8"
                                    >
                                      <v-text-field
                                        v-model.trim="address.address"
                                        label="Dirección"
                                        outlined
                                        dense
                                        required
                                      ></v-text-field>
                                    </v-col>
                                </v-row>
                              </v-container>
                            </v-form>
                          </template>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                    <v-expansion-panel key="addProduct" hide-actions>
                      <v-expansion-panel-header>
                        <v-row
                          align="center"
                          class="spacer"
                          no-gutters
                        >
                          <v-col
                            cols="4"
                            sm="2"
                            md="1"
                          >
                            <v-avatar size="36px">
                              <v-icon color="red">assistant_direction</v-icon>
                            </v-avatar>
                          </v-col>

                          <v-col
                            class="hidden-xs-only"
                            sm="5"
                            md="3"
                          >
                            <strong>AGREGAR PRODUCTOS AL DETALLE</strong>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>

                      <v-expansion-panel-content>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-container>
                            <v-row justify="center">
                              <v-col cols="12" md="12" xs="12">
                                <v-row>
                                  <v-col cols="12" md="8" xs="12">
                                    <v-row>
                                      <v-col
                                        cols="12"
                                        md="12"
                                      >
                                        <v-select
                                          v-model="selected.product"
                                          :items="select.products"
                                          item-value="id"
                                          item-text="name"
                                          label="Productos"
                                          dense
                                          outlined
                                        >
                                          <template v-slot:prepend-item>
                                            <v-list-item>
                                              <v-list-item-content>
                                                <v-text-field
                                                  v-model="searchProduct"
                                                  placeholder="Buscar"
                                                  @input="searchArticulos"
                                                  dense
                                                  outlined
                                                ></v-text-field>
                                              </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mt-2"></v-divider>
                                          </template>
                                        </v-select>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="5"
                                      >
                                        <v-select
                                          v-model="selected.productColor"
                                          :items="select.productColors"
                                          item-value="id"
                                          item-text="color.name"
                                          label="Colores"
                                          dense
                                          outlined
                                        ></v-select>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="5"
                                      >
                                        <v-select
                                          v-model="selected.productColorSize"
                                          :items="select.productColorSizes"
                                          item-value="id"
                                          item-text="size.name"
                                          label="Tallas"
                                          dense
                                          outlined
                                        ></v-select>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="2"
                                        class="d-flex"
                                      >
                                        <v-text-field
                                          v-model="stock"
                                          label="Stock"
                                          :background-color="stock && stock > 0 ? 'green' : 'red'"
                                          outlined
                                          dense
                                          disabled
                                        ></v-text-field>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="5"
                                      >
                                        <v-btn-toggle
                                          v-model="selectedPriceType"
                                          dense
                                          color="primary"
                                          class="d-flex"
                                          style="width:100%;"
                                        >
                                          <v-btn
                                            value="sale"
                                            :input-value="selectedPriceType === 'sale'"
                                            @click="selectPrice('sale')"
                                            class="flex-grow-1"
                                          >
                                            P. VENT
                                          </v-btn>
                                          <v-btn v-if="live_price"
                                            value="live"
                                            :input-value="selectedPriceType === 'live'"
                                            @click="selectPrice('live')"
                                            class="flex-grow-1"
                                          >
                                            P. LIVE
                                          </v-btn>
                                          <v-btn v-if="clearance_price"
                                            value="clearance"
                                            :input-value="selectedPriceType === 'clearance'"
                                            @click="selectPrice('clearance')"
                                            class="flex-grow-1"
                                          >
                                            P. LIQU
                                          </v-btn>
                                        </v-btn-toggle>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="4"
                                      >
                                        <v-text-field
                                          :label="
                                            `Precio Unitario 
                                            ${selectedPriceLabel} 
                                            ${(off && selectedPriceType === 'sale' ? off + '% dsc' : '')}`"
                                          :value="selected_price"
                                          disabled
                                          outlined
                                          dense
                                        ></v-text-field>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="3"
                                      >
                                        <v-text-field
                                          v-model.number="quantity"
                                          label="Cantidad"
                                          type="number"
                                          min="0"
                                          step="1"
                                          outlined
                                          dense
                                          :rules="[
                                            v => Number.isInteger(v) || 'Solo se permiten números enteros',
                                            v => v >= 0 || 'El monto debe ser mayor o igual a 0'
                                          ]"
                                        ></v-text-field>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="4"
                                      >
                                        <v-btn
                                          :disabled="(!quantity || quantity <= 0) || stock <= 0 || !selected_price"
                                          color="primary"
                                          block
                                          depressed
                                          @click="addProduct"
                                        >
                                          AGREGAR PRODUCTO
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-col>

                                  <v-col cols="12" md="4" xs="12">
                                    <v-row justify="center">
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <v-card style="border: 0" outlined elevation="0">
                                          <v-img
                                            :src="productColorImageUrl"
                                            :key="productColorImageUrl"
                                            height="auto"
                                          >
                                            <template v-slot:placeholder>
                                              <v-row
                                                class="fill-height ma-0"
                                                align="center"
                                                justify="center"
                                              >
                                                <v-progress-circular
                                                  indeterminate
                                                  color="primary lighten-5"
                                                ></v-progress-circular>
                                              </v-row>
                                            </template>
                                            <template v-if="off">
                                              <div class="text-right">
                                                <v-chip
                                                  class="ma-0 short"
                                                  color="pink"
                                                  label
                                                  text-color="white"
                                                >
                                                  <v-icon left>
                                                    mdi-label
                                                  </v-icon>
                                                  <b class="body-2">- {{ off }}%</b>
                                                </v-chip>
                                              </div>
                                            </template>
                                          </v-img>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel key="partialOderDetail" hide-actions>
                      <v-expansion-panel-header>
                        <v-row
                          align="center"
                          class="spacer"
                          no-gutters
                        >
                          <v-col
                            cols="4"
                            sm="2"
                            md="1"
                          >
                            <v-avatar size="36px">
                              <v-icon color="red">assistant_direction</v-icon>
                            </v-avatar>
                          </v-col>

                          <v-col
                            class="hidden-xs-only"
                            sm="5"
                            md="3"
                          >
                            <strong>DETALLE DE VENTA</strong>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>

                      <v-expansion-panel-content>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-data-table
                                  :headers="partialOrderHeaders"
                                  :items="partialOrderItems"
                                >
                                  <template v-slot:item.accion="{ item, index }">
                                    <v-btn
                                      depressed
                                      color="primary"
                                      @click="removeRow(index, item)"
                                      :disabled="partialOrder.id ? true : false"
                                    >
                                      <v-icon dark>
                                        delete
                                      </v-icon>
                                    </v-btn>
                                  </template>
                                </v-data-table>
                              </v-col>
                              <v-col
                                cols="12"
                                md="3"
                                offset-md="9"
                              >
                                <v-text-field
                                  v-model="partialOrder.subtotal"
                                  label="Subtotal"
                                  outlined
                                  dense
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="3"
                                offset-md="9"
                                class="mt-n10"
                              >
                                <v-text-field
                                  v-model="partialOrder.shipping_price"
                                  label="Costo de Entrega"
                                  type="number"
                                  outlined
                                  dense
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="3"
                                offset-md="9"
                                class="mt-n10"
                              >
                                <v-text-field
                                  v-model="partialOrder.coupon"
                                  label="Dsc Cupón (-)"
                                  type="number"
                                  outlined
                                  dense
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="3"
                                offset-md="9"
                                class="mt-n10"
                              >
                                <v-text-field
                                  v-model="partialOrder.total"
                                  label="Total"
                                  outlined
                                  dense
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="3"
                                offset-md="9"
                                class="mt-n10"
                              >
                                <v-text-field
                                  v-model="partialOrder.advance_payment"
                                  label="Adelanto (-)"
                                  type="number"
                                  outlined
                                  dense
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="3"
                                offset-md="9"
                                class="mt-n10"
                              >
                                <v-text-field
                                  v-model="partialOrder.pending_payment"
                                  label="Pendiente"
                                  outlined
                                  dense
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panel>
                </v-expansion-panels>

                <v-col
                  cols="12"
                  md="4"
                  offset-md="8"
                >
                  <v-btn
                    :disabled="partialOrderItems.length == 0 ? true : false"
                    color="primary"
                    block
                    depressed
                    @click="saveSale()"
                  >
                    REGISTRAR VENTA
                  </v-btn>
                </v-col>
              </v-col>
            </v-row>
          </template>
        </div>
      </template>

      <template>
        <v-dialog
          v-model="dialogClients"
          lg
        >
          <v-card>
            <v-card-title class="primary dark">
              <template>
                <v-tabs
                  v-model="tab"
                  background-color="primary"
                  dark
                >
                  <v-tab href="#tab-1">Clientes encontrados</v-tab>
                </v-tabs>
              </template>
            </v-card-title>

            <v-card-text>
              <v-tabs-items v-model="tab">
                <v-tab-item
                  key="1"
                  value="tab-1"
                >
                  <v-card flat>
                    <v-card-text>
                      <template>
                        <v-form ref="form" v-model="validForm">
                          <v-container>
                            <v-row>
                              <v-col
                                cols="12"
                                md="12"
                              >
                                <v-text-field
                                  v-model="searchClientTable"
                                  append-icon="mdi-magnify"
                                  label="Filtrar datos de la tabla"
                                  single-line
                                  hide-details
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="12"
                              >
                                <v-data-table
                                  :headers="headers"
                                  :items="items"
                                  :search="searchClientTable"
                                  :expanded.sync="expanded"
                                  show-expand
                                >
                                  <template v-slot:expanded-item="{ headers, item }">
                                    <td :colspan="headers.length">
                                      <template>
                                        <v-container
                                          class="px-0"
                                          fluid
                                        >
                                          <v-radio-group v-model="radioGroup">
                                            <v-radio
                                              v-for="data in item.address"
                                              :key="data.id"
                                              :label="`${data.shipping_type}: ${data.address}`"
                                              :value="data"
                                            ></v-radio>
                                          </v-radio-group>
                                        </v-container>
                                      </template>
                                    </td>
                                  </template>

                                  <template v-slot:item.actions="{ item }">
                                    <v-row
                                      align="center"
                                      class="spacer"
                                      no-gutters
                                    >
                                      <v-btn
                                        depressed
                                        color="primary"
                                        @click="selectdClient(item)"
                                        class="ma-2"
                                      >
                                        SELECCIONAR
                                      </v-btn>
                                    </v-row>
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="adm_orange"
                text
                @click="dialogClients = false"
              >
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <template>
        <div class="text-center ma-2">
          <v-snackbar
            v-model="snackbar"
            :color="color"
            top
            z-index="500"
          >
            {{ text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'
  import draggable from 'vuedraggable'
  import firebase from 'firebase'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  moment.locale('es');

  export default {
    name: 'ProductView',
    components: {
      DefaultLayout,
      draggable
    },
    data () {
      return {
        overlay: false,
        dialog: false,
        panel: [0, 1, 2],
        date: moment().toISOString(true).substr(0, 10),
        rules: {
          required: v => !!v || 'Por favor completar este campo'
        },
        findClient: null,
        modalDeliveryDay: false,
        provinces: [],
        districts: [],
        deliveryDistricts: [],
        searchProduct: '',
        productCopy: [],
        productColorSizes: [],
        select: {
          deliveryTypes: [
            { id: 1, name: 'DELIVERY' },
            { id: 2, name: 'RETIRO EN TIENDA' },
            { id: 3, name: 'SHALOM, MARVISUR U OTRO' }
          ],
          departments: [],
          provinces: [],
          districts: [],
          products: [],
          productColors: [],
          productColorSizes: []
        },
        selected: {
          product: null,
          productColor: null,
          productColorSize: null,
        },
        productColorImageUrl: null,
        partialOrder: {
          id: null,
          client_id: null,
          address_id: null,
          payment_type_id: null,
          shipping_type_id: null,
          shipping_price: 0,
          subtotal: null,
          coupon: 0,
          total: null,
          advance_payment: 0,
          pending_payment: null,
          coupon_code: null,
          opening_date: null
        },
        client: {
          id: null,
          email: null,
          name: null,
          last_name : '',
          identification_doc : null,
          phone: null,
          accept_conditions: 1,
          status: 1
        },
        address: {
          id: null,
          shipping_type_id: null,
          client_id: null,
          department_id: null,
          province_id: null,
          district_id: null,
          address: null,
          reference: null,
          primary: 1,
          status: 1
        },
        unit_price: null,
        live_price: null,
        clearance_price: null,
        selected_price: null,
        selectedPriceType: null,
        quantity: null,
        off: null,
        stock: null,
        partialOrderHeaders: [
          { text: 'PRODUCTO', value: 'product_name', width: '25%' },
          { text: 'COLOR', value: 'product_color_name', width: '10%' },
          { text: 'TALLA', value: 'product_color_size_name', width: '10%' },
          { text: 'UNI.', value: 'quantity', width: '10%' },
          { text: 'PRECIO UNI.', value: 'unit_price', width: '15%' },
          { text: 'TOTAL', value: 'amount', width: '20%' },
          { text: 'ACCIONES', value: 'accion', filterable: false, sortable: false, width: '10%' }
        ],
        partialOrderItems: [],
        dialogClients: false,
        tab: null,
        expanded: [],
        validForm: true,
        searchClientTable: '',
        headers: [
          { text: 'NOMBRE', value: 'name' },
          { text: 'APELLIDO', value: 'last_name'},
          { text: 'DNI/CE', value: 'identification_doc' },
          { text: 'CELULAR', value: 'phone' },
          { text: 'ACCIONES', value: 'actions', filterable: false, sortable: false }
        ],
        items: [],
        radioGroup: null,
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    computed: {
      dateText () {
        this.partialOrder.opening_date = this.date;
        return this.formatDateInit(this.date);
      },

      filteredDepartments() {
        return this.select.departments.filter(item => item.store == 1)
      },

      filteredProvinces() {
        return this.select.provinces.filter(item => item.store == 1)
      },
      filteredDistricts() {
        return this.select.districts.filter(item => item.store == 1)
      },
      selectedPriceLabel() {
        switch(this.selectedPriceType) {
          case 'sale':
            return '(VENTA)'
          case 'live':
            return '(LIVE)'
          case 'clearance':
            return '(LIQUIDACIÓN)'
          default:
            return ''
        }
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      selectPrice(type) {
        // si clickeas el mismo → deselecciona
        if (this.selectedPriceType === type) {
          this.selectedPriceType = null
          this.selected_price = null
          return
        }

        // si es diferente → selecciona normal
        this.selectedPriceType = type

        switch(type) {
          case 'sale':
            this.selected_price = this.unit_price
            break
          case 'live':
            this.selected_price = this.live_price
            break
          case 'clearance':
            this.selected_price = this.clearance_price
            break
          default:
            this.selected_price = null
        }
      },

      formatDateInit(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      onInputFindClient(value) {
        // Si el valor contiene al menos un dígito
        if (/^[0-9\s]+$/.test(value)) {
          // Elimina todos los espacios
          this.findClient = value.replace(/\s+/g, '');
        } else {
          // Si no es numérico, deja el texto como está
          this.findClient = value;
        }
      },

      getDeliveryDistricts () {
        axios.get(process.env.DINO.PATH.GET_DELIVERIES)
        .then(response => {
          this.select.departments = response.data.departments;
          this.provinces = response.data.provinces;
          this.districts = response.data.districts;
          this.deliveryDistricts = response.data.deliveryDistricts;
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      searchClient() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.SEARCH_CLIENT + this.findClient)
        .then(response => {
          if (response.data.length == 0) {
            this.showMessage(`No se encontró cliente con estos datos de búsqueda "${this.findClient}"`, 'deep-purple accent-4');
            this.cleanForm();
          } else if (response.data.length == 1) {
            this.client = response.data[0];
            const addressSize = response.data[0].address ? response.data[0].address.length : null;
            const latestAddress = addressSize ? response.data[0].address[addressSize-1] : null;

            if (latestAddress) {
              this.address.id = latestAddress.id;
              this.address.shipping_type_id = latestAddress.shipping_type_id;
              this.address.client_id = latestAddress.client_id;
              this.address.department_id = latestAddress.department_id;
              this.address.province_id = latestAddress.province_id;
              this.address.district_id = latestAddress.district_id;
              this.address.address = latestAddress.address;
              this.address.reference = latestAddress.reference;
              this.address.primary = latestAddress.primary;
            }
          } else if (response.data.length > 1) {
            this.dialogClients = true;
            this.items = response.data;
          }
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getProducts () {
        axios.get(process.env.DINO.PATH.GET_PRODUCTS)
        .then(response => {
          this.select.products = response.data;
          this.productCopy = [...response.data];
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      searchArticulos(e) {
        if (!this.searchProduct) {
          this.select.products = this.productCopy;
        }

        this.select.products = this.productCopy.filter((product) => {
          return product.name.toLowerCase().indexOf(this.searchProduct.toLowerCase()) > -1;
        });
      },

      getProductColors () {
        axios.get(process.env.DINO.PATH.GET_PRODUCT_COLORS.replace(':product_id', this.selected.product))
        .then(response => {
          this.select.productColors = response.data;
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      getProductColorSizes () {
        axios.get(process.env.DINO.PATH.GET_PRODUCT_COLOR_SIZES.replace(':product_id', this.selected.product))
        .then(response => {
          this.productColorSizes = response.data
        })
        .catch(err => {
        })
        .then(() => {
          if (this.select.productColors.length == 1 && this.select.productColors[0].color.name == 'NOT_COLOR') {
            this.selected.productColor = this.select.productColors[0].id;
          }
        });
      },

      validateStock() {
        this.partialOrderItems.forEach(function(obj) {
          amount = parseFloat(amount) + parseFloat(obj.amount);
          amount = parseFloat(amount).toFixed(2);
        });
      },

      addProduct () {
        if (this.quantity > this.stock) {
          this.showMessage(`Cantidad a comprar excede el stock actual`, 'deep-purple accent-4');
          return;
        }

        let productName, productColorName, productColorSizeName = '';
        const self = this;

        this.select.products.forEach(function(obj) {
          if (obj.id == self.selected.product) {
            productName = obj.name;
            return;
          }
        });

        this.select.productColors.forEach(function(obj) {
          if (obj.id == self.selected.productColor) {
            productColorName = obj.color.name;
            return;
          }
        });

        this.select.productColorSizes.forEach(function(obj) {
          if (obj.id == self.selected.productColorSize) {
            productColorSizeName = obj.size.name;
            return;
          }
        });

        const amountForProduct = parseInt(this.quantity) * parseFloat(this.selected_price);
        this.partialOrderItems.push({
          'product_id': this.selected.product,
          'product_color_id': this.selected.productColor,
          'product_color_size_id': this.selected.productColorSize,
          'product_name' : productName,
          'product_color_name' : productColorName,
          'product_color_size_name' : productColorSizeName,
          'quantity' : this.quantity,
          'priceType': this.selectedPriceType,
          'unit_price' : this.selected_price,
          'amount' : amountForProduct.toFixed(2)
        });

        let amount = 0;
        this.partialOrderItems.forEach(function(obj) {
          amount = parseFloat(amount) + parseFloat(obj.amount);
          amount = parseFloat(amount).toFixed(2);
        });

        this.partialOrder.subtotal = amount;
        this.calculeAmounts();
        this.selected.product = null;
        this.selected.productColor = null;
        this.selected.productColorSize = null;
        this.select.productColors = [];
        this.select.productColorSizes = [];
        this.quantity = null;
        this.unit_price = null;
        this.live_price = null;
        this.clearance_price = null;
        this.selected_price = null;
        this.selectedPriceType = null;
        this.off = null;
        this.productColorImageUrl = null;
        this.stock = null;
      },

      getColorOrTextStatus(status, type) {
        let value = '';

        if (type === 'color') {
          value = status == 1 ? 'green' : 'red';
        } else if (type === 'text') {
          value = status == 1 ? 'ACTIVO' : 'INACTIVO';
        }

        return value;
      },

      selectdClient(item) {
        this.client.id = item.id;
        this.client.email = item.email;
        this.client.name = item.name;
        this.client.last_name = item.last_name;
        this.client.identification_doc = item.identification_doc;
        this.client.phone = item.phone;
        this.client.accept_conditions = item.accept_conditions;
        this.client.status = item.status;

        if (this.radioGroup) {
          this.address.id = this.radioGroup.id;
          this.address.shipping_type_id = this.radioGroup.shipping_type_id;
          this.address.client_id = this.radioGroup.client_id;
          this.address.department_id = this.radioGroup.department_id;
          this.address.province_id = this.radioGroup.province_id;
          this.address.district_id = this.radioGroup.district_id;
          this.address.address = this.radioGroup.address;
          this.address.reference = this.radioGroup.reference;
          this.address.primary = this.radioGroup.primary;
          this.address.status = this.radioGroup.status;
          this.dialogClients = false;
        }
      },

      cleanForm() {
        this.partialOrder.id = null;
        this.partialOrder.client_id = null;
        this.partialOrder.address_id = null;
        this.partialOrder.payment_type_id = null;
        this.partialOrder.shipping_type_id = null;
        this.partialOrder.shipping_price = 0;
        this.partialOrder.subtotal = null;
        this.partialOrder.coupon = 0;
        this.partialOrder.total = null;
        this.partialOrder.advance_payment = 0;
        this.partialOrder.pending_payment = null;
        this.partialOrder.coupon_code = null;
        this.partialOrder.opening_date = this.date;
        this.client.id = null;
        this.client.email = null;
        this.client.name = null;
        this.client.last_name = '';
        this.client.identification_doc = null;
        this.client.phone = null;
        this.client.accept_conditions = 1;
        this.client.status = 1;
        this.address.id = null;
        this.address.shipping_type_id = null;
        this.address.client_id = null;
        this.address.department_id = null;
        this.address.province_id = null;
        this.address.district_id = null;
        this.address.address = null;
        this.address.reference = null;
        this.address.primary = null;
        this.address.status = 1;
        this.partialOrderItems = [];
      },

      getProductImagesForTypeAndColor () {
        axios.get(process.env.DINO.PATH.GET_PRODUCT_COLOR_IMAGES_FOR_TYPE_AND_COLOR
          .replace(':product_color_id', this.selected.productColor)
          .replace(':type', 'mediano')
        )
        .then(response => {
          const self = this;
          response.data.forEach(function(obj) {
            if (obj.order == 1) {
              self.productColorImageUrl = obj.image;
            }
          });
        })
        .catch(err => {
        });
      },

      calculeAmounts() {
        const subtotal = parseFloat(this.partialOrder.subtotal) || 0;
        const shippingPrice = parseFloat(this.partialOrder.shipping_price) || 0;
        const coupon = parseFloat(this.partialOrder.coupon) || 0;
        const total = parseFloat(subtotal + shippingPrice - coupon).toFixed(2);
        const advancePayment = this.partialOrder.advance_payment ? parseFloat(this.partialOrder.advance_payment) : 0;

        this.partialOrder.total = total;
        this.partialOrder.pending_payment = parseFloat(total - advancePayment).toFixed(2);
      },

      removeRow: function (index, item) {
        this.partialOrderItems.splice(index, 1);
        this.partialOrder.subtotal -= parseFloat(item.amount).toFixed(2);
        this.partialOrder.total -= parseFloat(item.amount).toFixed(2);
        this.calculeAmounts();
      },

      saveSale() {
        if (this.partialOrder.pending_payment < 0) {
          this.showMessage(`El monto pendiente a pagar no puede ser negativo, validar si el adelanto es mayor al monto total.`, 'deep-purple accent-4');
          return;
        }

        if (!this.client.name) {
          this.showMessage(`Falta ingresar nombre de cliente.`, 'deep-purple accent-4');
          return;
        }

        if (!this.client.phone) {
          this.showMessage(`Falta inngresar número de celular.`, 'deep-purple accent-4');
          return;
        }

        if (this.partialOrder.shipping_price < 0) {
          this.showMessage(`El costo de entrega no puede ser negativo.`, 'deep-purple accent-4');
          return;
        }

        if (this.partialOrder.coupon < 0) {
          this.showMessage(`El descuento del cupón no puede ser negativo.`, 'deep-purple accent-4');
          return;
        }

        if (this.partialOrder.advance_payment < 0) {
          this.showMessage(`El adelanto no puede ser negativo.`, 'deep-purple accent-4');
          return;
        }

        if (this.partialOrder.shipping_price === '' ||
          this.partialOrder.shipping_price === null ||
          isNaN(this.partialOrder.shipping_price)
        ) {
          this.partialOrder.shipping_price = 0
        }

        if (this.partialOrder.coupon === '' ||
          this.partialOrder.coupon === null ||
          isNaN(this.partialOrder.coupon)
        ) {
          this.partialOrder.coupon = 0
        }

        if (this.partialOrder.advance_payment === '' ||
          this.partialOrder.advance_payment === null ||
          isNaN(this.partialOrder.advance_payment)
        ) {
          this.partialOrder.advance_payment = 0
        }

        const request = {
          'client': this.client,
          'address': this.address,
          'partialOrder': this.partialOrder,
          'partialOrderDetail': this.partialOrderItems
        };

        axios.post(process.env.DINO.PATH.SAVE_PARTIAL_ORDER, request)
        .then(response => {
          const color = response.data.success ? 'green' : 'red';
          this.showMessage(response.data.message, color);
          if (response.data.success) {
            this.cleanForm();
          }
        })
        .catch(err => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        });
      }
    },
    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.getDeliveryDistricts();
      this.getProducts();
    },
    watch: {
      'address.department_id': function (val) {
        if (val) {
          const self = this;
          this.provinces.forEach(function(obj) {
            if (obj.department_id == val) {
              self.select.provinces.push(obj);
            }
          });
        }
      },
      'address.province_id': function (val) {
        if (val) {
          const self = this;
          this.districts.forEach(function(obj) {
            if (obj.province_id == val) {
              self.select.districts.push(obj);
            }
          });
        }
      },
      'address.district_id': function (val) {
        if (val) {
          if (this.address.shipping_type_id == 1) {
            const self = this;
            this.deliveryDistricts.forEach(function(obj) {
              if (obj.district_id == val) {
                if (obj.size == 2) {
                  self.partialOrder.shipping_price = obj.price;
                  const coupon = self.partialOrder.coupon > 0 ? self.partialOrder.coupon : 0;
                  const total = (parseFloat(self.partialOrder.subtotal) + parseFloat(obj.price)) - parseFloat(coupon);
                  self.partialOrder.total = parseFloat(total).toFixed(2);
                }
              }
            });
          } else if (this.address.shipping_type_id == 2) {
            this.address.address = 'Almacén Villa el Salvador\nAv. Mariano Pastor Sevilla & Av. Talara, Villa EL Salvador 15837'
          } else if (this.address.shipping_type_id == 3) {
            this.address.address = 'SHALOM'
          }
        }
      },
      'selected.product' (val) {
        if (val) {
          const self = this;
          this.quantity = null;
          this.selected_price = null;
          this.selectedPriceType = null;
          this.select.productColors = [];
          this.select.productColorSizes = [];
          this.select.products.forEach(function(obj) {
            if (obj.id == self.selected.product) {
              self.unit_price = obj.off > 0 ? obj.sale_price : obj.regular_price;
              self.off = obj.off;
              self.live_price = obj.live_price;
              self.clearance_price = obj.clearance_price;
              return;
            }
          });
          this.getProductColors();
          this.getProductColorSizes();
        }
      },
      'selected.productColor' (val) {
        if (val) {
          const self = this;

          this.select.productColorSizes = [];
          this.productColorSizes.forEach(function(obj) {
            if (obj.product_color_id == val) {
              self.select.productColorSizes.push(obj);
            }
          });

          if (this.select.productColorSizes.length == 1 && this.select.productColorSizes[0].size.name == 'NOT_SIZE') {
            this.selected.productColorSize = this.select.productColorSizes[0].id;
          }

          this.getProductImagesForTypeAndColor();
        }
      },
      'selected.productColorSize' (val) {
        if (val) {
          const self = this;
          this.productColorSizes.forEach(function(obj) {
            if (obj.id == val) {
              self.stock = obj.stock;
            }
          });
        }
      },
      'partialOrder.shipping_price' (newShippingPrice, oldShippingPrice) {
        if (newShippingPrice != oldShippingPrice) {
          this.calculeAmounts();
        }
      },
      'partialOrder.coupon' (newCoupon, oldCoupon) {
        if (newCoupon !== oldCoupon) {
          this.calculeAmounts();
        }
      },
      'partialOrder.advance_payment' (val) {
        val = parseFloat(val) || 0;
        this.partialOrder.pending_payment = parseFloat(this.partialOrder.total - parseFloat(val).toFixed(2)).toFixed(2);
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/order/Sale.vue